import {Award} from './award';
import {Testamonial} from './testamonial';

export enum RatingBarType {
  Text,
  Stars
}

export enum RatingBarSize {
  Full,
  Half,
  Mini
}

export enum RatingBarColor {
  Orange,
  Grey
}

export class FeedbackInfo {
  type: string;
  verifiedURL: string;
  showVerified: boolean;
  showComments = true;

  footerHTML: string;
  awards: Award[] = [];
  testimonials: Testamonial[] = [];

  constructor(public data: any) {
    const json: JSON = data['ratings'];

    this.verifiedURL = json['avidVerified']['url'];
    this.showVerified = json['avidVerified']['isDisplayed'];
    this.footerHTML = json['footer'];

    if (json['awards']) {
      for (const award of json['awards']) {
        this.awards.push(new Award(award));
      }
    }

    if (json['carousel']) {
      for (const test of json['carousel']) {
        this.testimonials.push(new Testamonial(test));
      }
    }
  }
}








// WEBPACK FOOTER //
// ./src/app/model/feedback-info.ts